export class ApiClient {

    constructor(url) {
        this.url = url;
    }

    async get(headers = {}) {
        try {
            const response = await fetch(this.url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers,
                },
            });

            if (!response.ok) {
                throw new Error(`GET request failed with status ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('GET request error:', error);
            throw error;
        }
    }

    async post(data, headers = {}) {
        try {
            const response = await fetch(this.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers,
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error(`POST request failed with status ${response.status}`);
            }

            return await response.json();
        } catch (error) {

            throw error;
        }
    }
}
